import { createSelector } from "reselect";

// Исходные селекторы
const originalObjectsArray = (state) => state.objects.allObjects;
const originalTrackObjectsObjectsArray = (state) => state.objects.trackObjects;

const originalObjectGroupsArray = (state) => state.objectsGroup.groups;
const originalTagsArray = (state) => state.objectsByTags.tags;


const searchObjectValue = (state) => state.search["objects"].value;

const originalPlaylistsArray  = state => state.playlists.allPlaylists
const originalAllPlaylistsArray  = state =>  state.public_playlists.allPublicPlaylists

const originalAllVideoPlaylistsArray  = state => state.videolists.allVideolists

const originalAll_All_VideoPlaylistsArray  = state => state.videolists_all.allVideolists

const searchPlaylistValue = (state) => state.search["playlists"].value;

const getTracksBase = state => state.tracks.tracks;
const getTracksTheme = state => state.tracks.tracksTheme;
const getTracksExtra = state => state.tracks.tracksExtra;

const searchTracksValue = (state) => state.search["tracks"].value;



// Мемоизированный селектор для вычисления data
export const getObjectsState = createSelector(
    [originalObjectsArray, searchObjectValue],
    (array, value) =>   
        value ? array.filter(item =>
            item['fullName']?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 || (item['id'].toString().indexOf(value?.toLowerCase()) !== -1)
        )
            : array
);

// Мемоизированный селектор для вычисления data
export const getTracksObjectsState = createSelector(
    [originalTrackObjectsObjectsArray, searchObjectValue],
    (array, value) =>   
        value ? array.filter(item =>
            item['fullName']?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 || (item['id'].toString().indexOf(value?.toLowerCase()) !== -1)
        )
            : array
);

export const getObjectGroupsState = createSelector(
    [originalObjectGroupsArray, searchObjectValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1)
            : array
);

export const getTagsState = createSelector(
    [originalTagsArray, searchObjectValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || item['id'].toString().indexOf(value) !== -1) 
            : array
);


export const getMusicPlaylists = createSelector(
    [originalPlaylistsArray, searchPlaylistValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || (item['id'].toString().indexOf(value) !== -1)
        )
            : array
);

export const getMusicAllPlaylists = createSelector(
    [originalAllPlaylistsArray, searchPlaylistValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || (item['id'].toString().indexOf(value) !== -1)
        )
            : array
);





export const getVideoPlaylists = createSelector(
    [originalAllVideoPlaylistsArray, searchPlaylistValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || (item['id'].toString().indexOf(value) !== -1)
        )
            : array
);

export const getVideoPlaylistsAll = createSelector(
    [originalAll_All_VideoPlaylistsArray, searchPlaylistValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || (item['id'].toString().indexOf(value) !== -1)
        )
            : array
);



export const getPlaylistsVideos = createSelector(
    [originalAllVideoPlaylistsArray, searchPlaylistValue],
    (array, value) =>
        value ? array.filter(item =>
            item['name']?.toLowerCase().indexOf(value) !== -1 || (item['id'].toString().indexOf(value) !== -1)
        )
            : array
);

export const getTracks = createSelector(
    [getTracksBase, getTracksTheme, getTracksExtra, searchTracksValue, (_, props) => props?.theme],
    (base, theme, extra, searchValue, propTheme) => {
      // 1. Выбираем нужный массив треков (по теме)
      const sourceTracks = 
        propTheme === 'extra' ? extra :
        propTheme ? theme : base;
  
      // 2. Фильтруем по поиску (если есть значение)
      if (!searchValue) return sourceTracks;
  
      const lowerSearch = searchValue?.toLowerCase();
      return sourceTracks.filter(item =>
        item.name?.toLowerCase().includes(lowerSearch) ||
        item.id.toString().includes(lowerSearch) ||
        item.text?.toString().includes(lowerSearch)||
        item.description?.toString().includes(lowerSearch)
      );
    }
  );